import Vue from 'vue'
import VueRouter from 'vue-router'
import isSuperAdmin from './middleware/superadmin'
import isModuleEnabled from './middleware/projectModule'
import userStore, { ensureUserLoaded } from '../stores/UserStore'
import { ensureProjectLoaded } from '../stores/ProjectsStore'

import Login from '../components/Pages/Login'
import ResetPassRequest from '../components/Pages/ResetPassRequest'
import ResetPass from '../components/Pages/ResetPass'
import NewUserPassword from '../components/Pages/NewUserPassword'

import PrivacyPolicy from '../components/Pages/PrivacyPolicy'
import ConfirmUserDelete from '../components/Pages/ConfirmUserDelete'

import Home from '../components/Views/Home/Dashboard'
import ProjectsIndex from '../components/Views/Projects/ProjectsIndex'
import CompaniesIndex from '../components/Views/Companies/CompaniesIndex'
import ClosedProjectsIndex from '../components/Views/Projects/ClosedProjectsIndex'
import UsersIndex from '../components/Views/Users/Index'
import ConsultasIndex from '../components/Views/Consultas/ConsultasIndex'
import RdiIndex from '../components/Views/Rdi/RdiIndex'
import MeetingsIndex from '../components/Views/Meetings/MeetingsIndex'
import EntregasIndex from '../components/Views/Entregas/EntregasIndex'
import AdicionalesIndex from '../components/Views/Adicionales/AdicionalesIndex'
import CommunicationBooksIndex from '../components/Views/CommunicationBooks/CommunicationBooksIndex'
import Planimetria from '../components/Views/Planimetria/Index'

import Planning from '../components/Views/Planning/SimplePlanning'
import FileManager from '../components/Views/FileManager'

import StandaloneDocumentViewer from '../components/Globals/Helpers/StandaloneDocumentViewer'
import StandaloneForgeViewer from '../components/Globals/Helpers/StandaloneForgeViewer'
import DocumentsRevisionTablePage from '../components/Views/Documents'

// Admin

import AdminConfig from '../components/Views/Admin/AdminConfigIndex'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history', // https://router.vuejs.org/api/#mode
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes(){
	return [
    {
      path: '/newuser',
      name: 'NewUserPassword',
      meta: { label: 'NewUserPassword'},
      component: NewUserPassword
    },
    {
      path: '/login',
      name: 'Login',
      meta: { label: 'Login'},
      component: Login
    },
    {
      path: '/reset-pass-request',
      name: 'ResetPassRequest',
      meta: { label: 'ResetPassRequest'},
      component: ResetPassRequest
    },
    {
      path: '/reset-pass/:token',
      name: 'ResetPass',
      meta: { label: 'ResetPass'},
      component: ResetPass
    },
    {
      path: '/privacidad',
      name: 'PrivacyPolicy',
      meta: { label: 'PrivacyPolicy'},
      component: PrivacyPolicy
    },
    {
      path: '/confirm-deletion',
      name: 'ConfirmUserDelete',
      meta: { label: 'ConfirmUserDelete'},
      component: ConfirmUserDelete
    },
    {
      path: '/',
      name: 'Dashboard',
      meta: { label: 'Panel de Control'},
      component: Home
    },
    {
      path: '/projects',
      name: 'Proyectos',
      meta: { label: 'Proyectos'},
      component: ProjectsIndex
    },
    {
      path: '/companies',
      name: 'Companies',
      meta: { label: 'Empresas'},
      component: CompaniesIndex
    },
    {
			path: '/closed-projects',
			name: 'ClosedProjects',
      meta: { label: 'Proyectos Cerrados'},
			component: ClosedProjectsIndex
    },
    {
      path: '/users',
      name: 'Usuarios',
      meta: { label: 'Usuarios'},
      component: UsersIndex
    },
    {
      // code: tasks
      path: '/consultas',
      name: 'Consultas',
      meta: { label: 'Consultas', moduleCode: 'tasks'},
      component: ConsultasIndex
    },
    {
      // code: rdi
      path: '/rdi',
      name: 'Rdi',
      meta: { label: 'Rdi', moduleCode: 'rdi'},
      component: RdiIndex
    },
    {
      // code: meetings
      path: '/meetings',
      name: 'Meetings',
      meta: { label: 'Meetings', moduleCode: 'meetings'},
      component: MeetingsIndex
    },
    {
      // code: entrega
      path: '/entregas',
      name: 'Entregas',
      meta: { label: 'Entregas', moduleCode: 'entrega'},
      component: EntregasIndex
    },
    {
      // code: additional
      path: '/adicionales',
      name: 'Adicionales',
      meta: { label: 'Adicionales', moduleCode: 'additional'},
      component: AdicionalesIndex
    },
    {
      // code: communication_books
      path: '/communication-books',
      name: 'CommunicationBooks',
      meta: { label: 'Libros/Folios', moduleCode: 'communication_books'},
      component: CommunicationBooksIndex
    },
    {
      // code: planimetry
      path: '/planos',
      name: 'Planimetria',
      meta: { label: 'Planimetría', moduleCode: 'planimetry'},
      component: Planimetria
    },
    {
      // code: planning
      path: '/planning',
      name: 'Planning',
      meta: { label: 'Programación', moduleCode: 'planning'},
      component: Planning
    },
    {
      path: '/file-manager',
      name: 'FileManager',
      meta: { label: 'Gestor de Archivos'},
      component: FileManager
    },
    {
      // code: documents
      path: '/documents-revision',
      name: 'DocumentsRevision',
      meta: { label: 'Listado Documentos', moduleCode: 'documents'},
      component: DocumentsRevisionTablePage
    },
    {
      path: '/document-viewer',
      name: 'StandaloneDocumentViewer',
      meta: { label: 'Visor de Documentos'},
      component: StandaloneDocumentViewer
    },
    {
      path: '/forge-viewer',
      name: 'StandaloneForgeViewer',
      meta: { label: 'Visor de Autodesk'},
      component: StandaloneForgeViewer
    },

		// Admins
    {
      path: '/admin-config',
      name: 'AdminConfig',
      // requiresSuperAdmin: se valida en el guard de abajo contra isSuperAdmin()
      meta: { label: 'Administración de Proyectos', requiresSuperAdmin: true },
      component: AdminConfig
    }
]
}

router.beforeEach(async (to, from, next) => {
  const publicRoutes = ['Login', 'Register', 'ResetPassRequest', 'ResetPass', 'NewUserPassword']
  const freeRoutes = ['PrivacyPolicy', 'ConfirmUserDelete']

  // Espera a que el usuario y sus roles terminen de cargar antes de
  // resolver cualquier redirección (ver UserStore.ensureUserLoaded).
  await ensureUserLoaded()

  if (freeRoutes.includes(to.name)) {
    next()
  } else if (!publicRoutes.includes(to.name) && !userStore.state.isAuthenticated) {
    next({ name: 'Login' })
  } else if (publicRoutes.includes(to.name) && userStore.state.isAuthenticated) {
    next({ name: 'Dashboard' })
  } else if (to.meta.requiresSuperAdmin && !isSuperAdmin()) {
    next({ name: 'Dashboard' })
  } else if (to.meta.moduleCode) {
    // Espera la carga inicial del proyecto (si aún no terminó) antes de
    // decidir si el módulo está habilitado. Solo se paga este costo en
    // rutas que efectivamente dependen de un módulo.
    await ensureProjectLoaded()
    if (!isModuleEnabled(to.meta.moduleCode)) {
      next({ name: 'Dashboard' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router